import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useJobTrades = (jobId: string | undefined, orgId: string | undefined) => {
  return useQuery({
    queryKey: ["job-trades", jobId],
    queryFn: async () => {
      if (!jobId || !orgId) return [];
      
      const { data, error } = await supabase
        .from("job_trades")
        .select("*, trades(name, icon)")
        .eq("job_id", jobId)
        .eq("org_id", orgId)
        .order("created_at");

      if (error) throw error;
      return data || [];
    },
    enabled: !!jobId && !!orgId,
  });
};
